import React, { useEffect, useState } from 'react';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import { Block } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import Spinner from '../../../../../../components/Spinner';
import Processing from '@/presentation/components/Processing';
import constants from '../../../../constants';
import CardProgress from '../../../../../../reusables/CardProgress';
import requestInProgressImage from '../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../assets/illustrations/procedures/cards/progress_dsk.svg';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import {
  ProcedureInfoComponent,
  StepsToFollowComponent
} from '../info/components/ProcedureInfoComponent';
import CardPayment from './components/CardPayment';
import TextHelper from '@/core/helpers/TextHelper';

interface ReincorporationProgressViewProps {
  procedure: any;
  request: any;
  isLoadingDetail: boolean;
  onBackButton: () => void;
  handlerActivatePayment: () => void;
  isLoadingActivatePayment: boolean;
  isSuccessActivatePayment: boolean;
  enrolmentTurn: { date: string; hour: string };
}

const ReincorporationProgressView = ({
  procedure,
  request,
  isLoadingDetail,
  onBackButton,
  handlerActivatePayment,
  isLoadingActivatePayment,
  isSuccessActivatePayment,
  enrolmentTurn
}: ReincorporationProgressViewProps) => {
  const program = procedure?.detail?.newAcademicData?.program?.name;
  const campus = procedure?.detail?.newAcademicData?.campus?.name;
  const modality = procedure?.detail?.newAcademicData?.modality?.name;
  const endDate = procedure?.steps[2]?.date;

  const evalStatus = () =>
    constants.procedureStatus.reincorporated.find(
      (s: any) => s.name === request?.status.status
    );

  const enabledStep2 = () =>
    procedure?.detail?.newAcademicData?.program?.name ||
    procedure?.detail?.newAcademicData?.campus?.name ||
    procedure?.detail?.newAcademicData?.modality?.name;

  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);

  useEffect(() => {
    if (request) {
      const { requiresPayment, payed } = request;
      setIsPaymentActive(
        requiresPayment && evalStatus()?.name === 'PAGO_ACTIVADO' && !payed
      );
      setIsPaymentDone(requiresPayment && payed);
    }
  }, [request]);

  const resume = `<b>Resumen:</b>
  <ul>
    <li><b>Carrera:</b> ${TextHelper.capitalize(program)}.</li>
    <li><b>
      Modalidad:</b> ${TextHelper.capitalize(modality, false, true).replace(
        'Modalidad a',
        'A'
      )}.
    </li>
    <li><b>Campus:</b> ${TextHelper.capitalize(campus).replace(
      'Campus ',
      ''
    )}.</li>
  </ul>`;

  const formatResumePending = () => {
    const html = `
    <div class="resumeReincorporation">
    ${resume}
    Nuestro equipo está trabajando en tu solicitud. El plazo de atención es de 3 días hábiles.
    <div>`;
    return html;
  };
  const formatResumeSuccess = () => {
    let html = `
    <div class="resumeReincorporation">
    ${resume}
    Realiza el pago de tu matrícula y seguro estudiantil en los bancos autorizados.<br/>
    <a href="https://view.genial.ly/601c9064a5bc7a0d3b1f5154" target="_blank">Revisa cómo hacer tus pagos.</a>`;

    if (enrolmentTurn?.date) {
      html += `Tu turno de matrícula en línea está programada para el día ${enrolmentTurn?.date?.toLowerCase()} a las ${
        enrolmentTurn.hour
      }.<div>`;
    }
    html += '<div>';
    return html;
  };
  const formatResumeFailed = () => {
    const html = `
    <div class="resumeReincorporation">
    ${resume}
    <br/>
    ${request?.comentary}
    <div>`;
    return html;
  };

  return (
    <ContainerProcedure>
      <Processing isOpen={false} />
      {isLoadingDetail && <Spinner />}
      {!isLoadingDetail && procedure && (
        <SubContainer>
          <ButtonBack onClick={onBackButton} />
          <ToggleHeader
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            status={request?.status}
            // pin1={procedureSelectedInfo?.pin1}
            childContent={
              <>
                <ProcedureInfoComponent inRegister />
                <br />
                <StepsToFollowComponent />
              </>
            }
            twoLineFormat
            inRegister
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              name={procedure?.steps[0]?.name}
              order={procedure?.steps[0]?.order}
              isComplete
            >
              {procedure?.detail?.applySince}.
            </Step>
            {enabledStep2() ? (
              <Step
                name="Opciones de reincorporación"
                order={procedure?.steps[1]?.order}
                isComplete
              >
                <ul
                  style={{ listStyle: 'unset', marginLeft: 12, paddingLeft: 8 }}
                >
                  {campus && (
                    <li>
                      Campus:{' '}
                      {TextHelper.capitalize(campus)
                        .replace('Campus ', '')
                        .replace('Utp', 'UTP')}
                      .
                    </li>
                  )}
                  {program && (
                    <li>Carrera: {TextHelper.capitalize(program)}.</li>
                  )}
                  {modality && (
                    <li>
                      Modalidad:{' '}
                      {TextHelper.capitalize(modality)
                        .replace('Modalidad a', 'A')
                        .replace('a ', 'A ')}
                      .
                    </li>
                  )}
                </ul>
              </Step>
            ) : (
              <Step
                name={procedure?.steps[1]?.name}
                order={procedure?.steps[1]?.order}
                disabled
              >
                No se realizaron opciones de cambio.
              </Step>
            )}
            <Step
              name={procedure?.steps[2]?.name}
              order={procedure?.steps[2]?.order}
              isComplete={request?.requiresPayment && isPaymentDone}
              disabled={!request?.requiresPayment}
            >
              {request?.requiresPayment ? (
                <>
                  {evalStatus()?.name === 'CREADO' && (
                    <CardPayment
                      title="Genera el cargo de tu trámite activando tu pago"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Activar"
                      isPaymentActive={isPaymentActive}
                      isPaymentDone={isPaymentDone}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      firstDialogSubtitle={`Al aceptar, se cargará el monto de <br/>S/ ${procedure?.amount}.00 por opciones de cambio a tus pagos pendientes.`}
                      secondDialogSubtitle={
                        'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
                      }
                    />
                  )}
                  {evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone && (
                    <CardPayment
                      title="El pago ha sido activado"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Ir a pagos"
                      isPaymentActive
                      isPaymentDone={false}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                    />
                  )}
                  {evalStatus()?.name === 'PAGO_ACTIVADO' && isPaymentDone && (
                    <>Pago en proceso.</>
                  )}
                  {['FINALIZADO', 'PENDIENTE'].includes(
                    evalStatus()?.name || ''
                  ) && <>{endDate?.toLowerCase()}.</>}
                </>
              ) : (
                <>Este trámite no tiene costo.</>
              )}
            </Step>
            <Step
              name={procedure?.steps[3]?.name}
              order={procedure?.steps[3]?.order}
              isComplete={evalStatus()?.isComplete}
              disabled={request?.requiresPayment && !isPaymentDone}
              isLast
            >
              {(!evalStatus()?.isComplete && !request?.requiresPayment) ||
              (!evalStatus()?.isComplete &&
                !(request?.requiresPayment && !isPaymentDone)) ? (
                <CardProgress
                  image={[requestInProgressImage, requestInProgressDskImage]}
                  title={`Tu reincorporación para el ciclo ${procedure?.detail?.applySince} está pendiente`}
                  subtitle={formatResumePending()}
                />
              ) : (
                <></>
              )}
              {evalStatus()?.isComplete && evalStatus()?.isApproved && (
                <CardProgress
                  image={[documentSuccessImage, documentSuccessDskImage]}
                  title={`Tu reincorporación para el ciclo ${procedure?.detail?.applySince} ha sido aprobada`}
                  subtitle={formatResumeSuccess()}
                />
              )}
              {evalStatus()?.isComplete && !evalStatus()?.isApproved && (
                <CardProgress
                  image={[documentFailedImage, documentFailedDskImage]}
                  title={`Tu reincorporación para el ciclo ${procedure?.detail?.applySince} no procede`}
                  subtitle={formatResumeFailed()}
                />
              )}
            </Step>
          </Block>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default ReincorporationProgressView;
